import React, {useContext} from 'react';
import {
    Button,
    Container,
    Divider,
    Heading,
    Input,
    LinkButton,
    Offer,
    OfferSection,
    SubHeading,
    Wrapper,
} from './SignInOutForm.style';
import {Facebook, Google} from 'components/AllSvgIcon';
import {AuthContext} from 'contexts/auth/auth.provider';
import {FormattedMessage} from 'react-intl';
import BlockUi from "react-block-ui";
import {NotificationManager} from 'react-notifications';
import {ModalContext} from "contexts/modal.provider";
import notifications from "utils/notifications";

export default function SignInModal({initEmail = '', onClose}) {
    const {authDispatch, login, federatedSignIn} = useContext<any>(AuthContext);
    const [email, setEmail] = React.useState(initEmail);
    const [password, setPassword] = React.useState('');
    const [loading, setLoading] = React.useState(null);
    const {closeModal} = useContext(ModalContext);

    const toggleSignUpForm = () => {
        authDispatch({
            type: 'SIGNUP',
        });
    };

    const toggleForgotPassForm = () => {
        authDispatch({
            type: 'FORGOTPASS',
        });
    };


    const loginCallback = (e) => {
        e.preventDefault();
        if (typeof window !== 'undefined') {
            setLoading(true);
            login(email, password)
                .then((user) => {
                    NotificationManager.success(`Welcome ${user.attributes?.given_name || ''}`, 'Welcome Back!', 5000);
                    closeModal();
                    onClose();
                }).catch(e => {
                // This might be a user that was migrated and now logging in ffor the first time
                if (e.code === 'PasswordResetRequiredException') {
                    notifications.error(`You`, 'Please set your new password', 15000, true);
                    authDispatch({
                        type: 'MIGRATEPASS',
                    });
                } else {
                    notifications.error(e.message, 'Login Error', 5000, true);
                }
            })
                .finally(() => {
                    setLoading(false);
                });

        }
        return false;
    };

    const socialSignin = (provider) => {
        federatedSignIn({provider})

    };


    return (
        <Wrapper>
            <BlockUi tag={"div"} blocking={loading}>
                <Container>

                    <h3 className="font-bold text-xl text-scuttle-blue">
                        Welcome
                    </h3>

                    <SubHeading>
                        Please sign in with your email and password
                    </SubHeading>
                    <form onSubmit={loginCallback}>

                        <Input
                            type='email'
                            placeholder={'Email'}
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />


                        <Input
                            type='password'
                            placeholder={'Password'}
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                        />


                        <div className="mt-6">
                          <span className="block w-full rounded-md shadow-sm">
                            <button
                                onClick={loginCallback}
                                type="submit"
                                className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-bold rounded-md text-white bg-scuttle-orange"
                            >
                              Continue
                            </button>
                          </span>
                        </div>
                    </form>
                    <Divider>
          <span>
            or
          </span>
                    </Divider>

                    <Button
                        fullwidth
                        title={'Continue with Facebook'}
                        className='facebook'
                        icon={<Facebook/>}
                        iconPosition='left'
                        iconStyle={{color: '#ffffff', marginRight: 5}}
                        intlButtonId='continueFacebookBtn'
                        onClick={() => socialSignin('Facebook')}
                        style={{color: '#fff'}}
                    />

                    <Button
                        fullwidth
                        title={'Continue with Google'}
                        className='google'
                        icon={<Google/>}
                        iconPosition='left'
                        iconStyle={{color: '#ffffff', marginRight: 5}}
                        intlButtonId='continueGoogleBtn'
                        onClick={() => socialSignin('Google')}
                        style={{color: '#fff'}}
                    />

                    <div className="my-4">
                        <button className="text-base text-extrabold text-scuttle-orange underline  cursor-pointer"
                                onClick={toggleSignUpForm}>
                            Sign up for an account
                        </button>
                    </div>
                </Container>

                <div className="bg-gray-50 p-4">
                    <div className="my-2">
                        <p className="text-base text-extrabold text-scuttle-orange underline cursor-pointer"
                           onClick={toggleForgotPassForm}>
                            Reset password
                        </p>
                    </div>
                </div>
            </BlockUi>
        </Wrapper>
    );
}
